/**
 * VLAN Traffic Analysis
 *
 * @since 2020-10-20
 * @author ms1124.kim
 *
 */
// Prefix
const vlanApiPath = '/api/sm/vlan/interfaces'
const analysisApiPath = '/api/an/analysis'

export const state = () => ({
  vlans: [],
  panelList: [],
  selectedVlans: []
})

export const mutations = {
  /*
    이름: setVlans
    설명: VLAN 목록을 스토어에 저장한다. VLAN ID가 중복되지 않도록 처리한다.
  */
  setVlans (state, vlans = []) {
    state.vlans = vlans.filter((item, index) => vlans.indexOf(item) === index)
  },
  /*
    이름: setInitAnalysisData
    설명: 스토어의 데이터를 모두 초기화한다.
  */
  setInitAnalysisData (state) {
    state.vlans = []
    state.panelList = []
    state.selectedVlans = []
  },
  /*
    이름: setSelectedVlans
    설명: 저장된 VLAN을 스토어의 상태값에 저장한다.
  */
  setSelectedVlans (state, vlans) {
    state.selectedVlans = vlans
  },
  // TAMS
  // vlan 리스트 및 선택된 값 초기화
  initVlans (state) {
    state.vlans = []
    state.selectedVlans = []
  }
}

export const actions = {
  /*
    이름: startAnalysisData
    설명: 분석 데이터 조회를 시작한다.
  */
  async startAnalysisData ({ commit, state }, analysisParams) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$post(`${analysisApiPath}/start`, analysisParams, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getAnalysisStatus
    설명: 조회중인 분석 데이터의 상태를 가져온다.
  */
  async getAnalysisStatus ({ commit, state }, { requestId }) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$get(`${analysisApiPath}/${requestId}/status`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getAnalysisData
    설명: 분석이 중지 / 완료된 데이터를 가져온다.
  */
  async getAnalysisData ({ commit, state }, { requestId }) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$get(`${analysisApiPath}/${requestId}/result`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: stopAnalysisData
    설명: 진행 중인 조회 작업 중지를 요청한다.
  */
  async stopAnalysisData ({ commit, state }, { requestId }) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$delete(`${analysisApiPath}/${requestId}${'/stop'}`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: endAnalysisData
    설명: 조회 작업이 완료되면 호출된다. 서버의 리소스를 해제하는 명령어이므로 반드시 호출한다.
  */
  async endAnalysisData ({ commit, state }, { requestId }) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$delete(`${analysisApiPath}/${requestId}${'/end'}`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getDeviceVlans
    설명: 장비의 VLAN 목록을 불러온다.
  */
  async getDeviceVlans ({ state, commit }) {
    try {
      // 인터페이스 목록 불러오기
      const { code, result } = await this.$axios.$get(vlanApiPath)

      if (code === 'ok') {
        const vlanList = []

        for (const { vlan_id: vlanId } of result) {
          vlanList.push(vlanId)
        }

        commit('setVlans', vlanList)
      }
    } catch (e) {
      this.$log('[Vlan traffic analysis API Error (getDeviceVlans)] ', e)
    }
  },
  /*
    이름: getSelectedVlans
    설명: 마지막으로 선택한 VLAN 목록을 가져온다. (로컬 스토리지 구현 예정)
  */
  async getSelectedVlans ({ commit }) {
    // API 호출
    commit('setSelectedVlans', ['eth0'])
  },

  // TAMS
  // 선택한 장비에 대한 VLAN 목록 조회
  // 추후 REST API 연동 이후 연동 테스트 수행 필요 (2020-11-04)
  async getDeviceVlansMachId ({ state, commit }, { machId }) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      commit('initVlans')
      res = await this.$axios.$get(`/api/an/vlanid/${machId}`)

      if (res.code === 'ok') {
        const vlanList = []

        _.forEach(res.result.vlan_id, vlanId => {
          vlanList.push(vlanId)
        })

        commit('setVlans', vlanList)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}
export const getters = {}
export const strict = false
